import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { IUniversalMenuItemCTA } from '@klaviyo-mkt/gatsby-source-universal-navigation/src/types';

export const useAcademyCTAData = () => {
  const [path, setPath] = useState<string>('');
  const { t, i18n } = useTranslation();

  useEffect(() => {
    // we have to use an effect because
    // window is undefined during SSR
    // and an inline check (typeof window === 'undefined')
    // at the point of use does not update the path
    // during client hydration, while the effect forces an update
    setPath(window.location.pathname);
  }, []);

  const ctas = (onCredentialsPage = false) =>
    [
      {
        id: t('navigation_ecosystem_ctas_academy_signIn_label'),
        label: t('navigation_ecosystem_ctas_academy_signIn_label'),
        locale: i18n.language,
        url: `${process.env.GATSBY_IFRAME_SOURCE}${t(
          'navigation_ecosystem_ctas_academy_signIn_href',
        )}${path ? `?next=${encodeURIComponent(window.location.pathname)}` : ''}`,
        variant: 'primary',
      },
      onCredentialsPage
        ? {
          id: t('navigation_ecosystem_ctas_contactUs_label'),
          label: 'Visit Partner Portal',
          locale: i18n.language,
          url: 'https://partnerportal.klaviyo.com/s/login/?ec=302&startURL=%2Fs%2F',
          variant: 'secondary',
        }
        : {
          id: t('navigation_ecosystem_ctas_contactUs_label'),
          label: t('navigation_ecosystem_ctas_contactUs_label'),
          locale: i18n.language,
          url: t('navigation_ecosystem_ctas_contactUs_href'),
          variant: 'secondary',
        },
    ] satisfies IUniversalMenuItemCTA[];

  return ctas;
};
